import React, { useState } from "react";

import { Menu, MenuItem, Sidebar, SubMenu } from "react-pro-sidebar";
import { Link, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronCircleLeft } from "@fortawesome/free-solid-svg-icons";
import { faChevronCircleRight } from "@fortawesome/free-solid-svg-icons";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";

import { ModuleAccess } from "utils/moduleaccess";
import { includes } from "lodash";

const SidebarMenu = () => {
  const [open, setOpen] = useState(true);
  const [admin, setAdmin] = useState(false);
  const [financial, setFinancial] = useState(false);
  const [target, setTarget] = useState(null);
  const { pathname } = useLocation();
  const [show, setShow] = useState(false);

  const handleMouseEnter = (id) => {
    if (open == true) setTarget(id);
    setShow(true);
  };
  const handleMouseLeave = () => {
    if (open == true) setShow(false);
    setTarget(null);
  };
  const hasModule = (code) => {
    //return modules.length > 0 && modules.filter(m => m.code == code).length > 0;
    return ModuleAccess(code);
  };

  const toggleAdmin = () => {
    setAdmin(!admin);
    setFinancial(false);
  };
  const { token_type, access_token, profile } =
    JSON.parse(localStorage.getItem("pharmaforce")) || {};
  const { sub, roles } = profile || {};
  // debugger
  const toggleFinancial = () => {
    setAdmin(false);
    setFinancial(!financial);
  };

  const renderTaskBoard = () => {
    if (ModuleAccess("TB", "")) {
      return (
        <>
          <OverlayTrigger
            overlay={(props) => <Tooltip {...props}>TaskBoard</Tooltip>}
            placement="right"
            show={show && target == "TaskBoard"}
          >
            <MenuItem
              component={
                <Link
                  className={`${includes(pathname, "/taskboard") ? "active" : ""
                    }`}
                  to="/taskboard"
                />
              }
              id="TaskBoard"
              onMouseEnter={() => handleMouseEnter("TaskBoard")}
              onMouseLeave={handleMouseLeave}
              icon={

                <svg width="12" height="17" viewBox="0 0 12 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M2.56523 5.84872C2.75339 5.84872 2.90539 6.00104 2.90539 6.18887C2.90539 6.37607 2.75339 6.52838 2.56523 6.52838C2.37804 6.52838 2.22572 6.37607 2.22572 6.18887C2.22572 6.00136 2.37804 5.84872 2.56523 5.84872ZM2.90539 8.73026C2.90539 8.91745 2.75339 9.06977 2.56523 9.06977C2.37804 9.06977 2.22572 8.91745 2.22572 8.73026C2.22572 8.54274 2.37804 8.3901 2.56523 8.3901C2.75339 8.3901 2.90539 8.54274 2.90539 8.73026ZM2.22572 11.2713C2.22572 11.0838 2.37804 10.9312 2.56523 10.9312C2.75339 10.9312 2.90539 11.0835 2.90539 11.2713C2.90539 11.4585 2.75339 11.6108 2.56523 11.6108C2.37804 11.6108 2.22572 11.4585 2.22572 11.2713ZM2.56523 13.4729C2.75339 13.4729 2.90539 13.6252 2.90539 13.813C2.90539 14.0002 2.75339 14.1525 2.56523 14.1525C2.37804 14.1525 2.22572 14.0002 2.22572 13.813C2.22572 13.6252 2.37804 13.4729 2.56523 13.4729ZM3.74569 13.8124C3.74569 13.6562 3.87208 13.5298 4.02824 13.5298H10.2115C10.3676 13.5298 10.494 13.6562 10.494 13.8124C10.494 13.9682 10.3676 14.0949 10.2115 14.0949H4.02824C3.87208 14.0949 3.74569 13.9682 3.74569 13.8124ZM4.02824 10.9888H10.2115C10.3676 10.9888 10.494 11.1155 10.494 11.2713C10.494 11.4272 10.3676 11.5539 10.2115 11.5539H4.02824C3.87208 11.5539 3.74569 11.4272 3.74569 11.2713C3.74569 11.1155 3.87208 10.9888 4.02824 10.9888ZM4.02824 8.44738H10.2115C10.3676 8.44738 10.494 8.57378 10.494 8.72994C10.494 8.88609 10.3676 9.01249 10.2115 9.01249H4.02824C3.87208 9.01249 3.74569 8.88609 3.74569 8.72994C3.74569 8.57378 3.87208 8.44738 4.02824 8.44738ZM4.02824 5.90632H10.2115C10.3676 5.90632 10.494 6.0324 10.494 6.18887C10.494 6.34503 10.3676 6.47111 10.2115 6.47111H4.02824C3.87208 6.47111 3.74569 6.34503 3.74569 6.18887C3.74569 6.0324 3.87208 5.90632 4.02824 5.90632ZM6.49186 1.67057C6.49186 1.83697 6.35651 1.97265 6.18979 1.97265C6.0234 1.97265 5.88772 1.83729 5.88772 1.67057C5.88772 1.50386 6.02308 1.3685 6.18979 1.3685C6.35651 1.3685 6.49186 1.50386 6.49186 1.67057ZM9.03965 2.87535C9.03965 2.2216 8.50398 1.68593 7.84959 1.68593H7.48064C7.47744 1.36306 7.34433 1.06931 7.13153 0.856512C6.65634 0.381003 5.72324 0.381323 5.24805 0.856512C5.03526 1.06931 4.90214 1.36274 4.89894 1.68593H4.53863C3.88328 1.68593 3.3489 2.22032 3.3489 2.87567C3.3489 3.52941 3.88424 4.06572 4.53863 4.06572H7.84991C8.50366 4.06604 9.03965 3.52909 9.03965 2.87535ZM11.606 2.49008H9.47388C9.50364 2.61519 9.51932 2.74447 9.51932 2.87535C9.51932 3.79213 8.76989 4.54539 7.84991 4.54539H4.53863C3.61833 4.54539 2.86923 3.79309 2.86923 2.87567C2.86923 2.74447 2.88459 2.61519 2.91435 2.48976H0.782554C0.626397 2.48976 0.5 2.61615 0.5 2.77231V16.2174C0.5 16.3736 0.626397 16.5 0.782554 16.5H11.6063C11.7625 16.5 11.8889 16.3736 11.8889 16.2178V2.77263C11.8885 2.61647 11.7621 2.49008 11.606 2.49008Z" fill="#757575" />
                </svg>


              }
            >
              TaskBoard
            </MenuItem>
          </OverlayTrigger>
        </>
      );
    }
  };

  const renderClaimsManager = () => {
    if (ModuleAccess("CLM", "")){
      return (
        <>
          <OverlayTrigger
            overlay={(props) => <Tooltip {...props}>Claims Manager</Tooltip>}
            placement="right"
            show={show && target == "claimsmanager"}
          >
            <MenuItem
              component={
                <Link
                  className={`${includes(pathname, "/claims-manager") ? "active" : ""
                    }`}
                  to="/claims-manager"
                />
              }
              id="claimsmanager"
              onMouseEnter={() => handleMouseEnter("claimsmanager")}
              onMouseLeave={handleMouseLeave}
              icon={


                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M15.9825 11.3498L15.1984 9.51724C15.168 9.44544 15.0979 9.39914 15.0207 9.39914C15.0107 9.39914 15.0015 9.39981 14.9916 9.40115C14.9704 9.40451 14.9447 9.40585 14.9116 9.40585C14.7531 9.40585 14.3812 9.36559 13.856 9.25286C13.2845 9.13006 12.9978 9.02135 12.9007 8.98043L12.8214 8.94688L12.8227 0.196605C12.8227 0.0885694 12.7362 0 12.6292 0H0.193559C0.087197 0 0 0.0879046 0 0.196605V15.2156C0 15.3236 0.0865425 15.4122 0.193559 15.4122H11.6879L11.7222 15.4377C11.9719 15.6262 12.2434 15.8061 12.5288 15.9738C12.5586 15.9913 12.5916 16 12.6259 16C12.6596 16 12.6933 15.9906 12.7231 15.9738C14.5768 14.8848 15.6781 13.3662 15.9971 11.4611C16.0037 11.4235 15.9991 11.3846 15.9839 11.3497L15.9825 11.3498ZM8.16931 3.7249C8.16931 3.61686 8.25585 3.52829 8.36287 3.52829C8.46989 3.52829 8.55643 3.6162 8.55643 3.7249V3.9215H9.44299V3.21223H8.61919C8.37146 3.21223 8.16997 3.00757 8.16997 2.75594V2.24595C8.16997 1.99432 8.37146 1.78966 8.61919 1.78966H8.83125V1.49239C8.83125 1.38436 8.91779 1.29579 9.02481 1.29579C9.13183 1.29579 9.21837 1.38369 9.21837 1.49239V1.78966H9.38154C9.62927 1.78966 9.83076 1.99432 9.83076 2.24595V2.36271C9.83076 2.47075 9.74422 2.55932 9.6372 2.55932C9.53018 2.55932 9.44364 2.47141 9.44364 2.36271V2.1822H8.55708V2.819H9.38088C9.62861 2.819 9.8301 3.02366 9.8301 3.27529V3.85774C9.8301 4.10936 9.62861 4.31402 9.38088 4.31402H9.21771V4.61129C9.21771 4.71933 9.13117 4.8079 9.02415 4.8079C8.91713 4.8079 8.83059 4.72 8.83059 4.61129V4.31402H8.61853C8.3708 4.31402 8.16931 4.10936 8.16931 3.85774V3.7249ZM5.68476 3.7249C5.68476 3.61686 5.7713 3.52829 5.87832 3.52829C5.98534 3.52829 6.07188 3.6162 6.07188 3.7249V3.9215H6.95844V3.21223H6.13464C5.88691 3.21223 5.68542 3.00757 5.68542 2.75594V2.24595C5.68542 1.99432 5.88691 1.78966 6.13464 1.78966H6.3467V1.49239C6.3467 1.38436 6.43324 1.29579 6.54026 1.29579C6.64728 1.29579 6.73381 1.38369 6.73381 1.49239V1.78966H6.89699C7.14472 1.78966 7.34621 1.99432 7.34621 2.24595V2.36271C7.34621 2.47075 7.25966 2.55932 7.15265 2.55932C7.04563 2.55932 6.95909 2.47141 6.95909 2.36271V2.1822H6.07252V2.819H6.89633C7.14406 2.819 7.34555 3.02366 7.34555 3.27529V3.85774C7.34555 4.10936 7.14406 4.31402 6.89633 4.31402H6.73315V4.61129C6.73315 4.71933 6.64661 4.8079 6.5396 4.8079C6.43257 4.8079 6.34604 4.72 6.34604 4.61129V4.31402H6.13398C5.88625 4.31402 5.68476 4.10936 5.68476 3.85774V3.7249ZM3.2002 3.7249C3.2002 3.61686 3.28675 3.52829 3.39376 3.52829C3.50078 3.52829 3.58732 3.6162 3.58732 3.7249V3.9215H4.47389V3.21223H3.65008C3.40235 3.21223 3.20086 3.00757 3.20086 2.75594V2.24595C3.20086 1.99432 3.40235 1.78966 3.65008 1.78966H3.86214V1.49239C3.86214 1.38436 3.94868 1.29579 4.0557 1.29579C4.16272 1.29579 4.24926 1.38369 4.24926 1.49239V1.78966H4.41243C4.66016 1.78966 4.86165 1.99432 4.86165 2.24595V2.36271C4.86165 2.47075 4.77511 2.55932 4.66809 2.55932C4.56107 2.55932 4.47454 2.47141 4.47454 2.36271V2.1822H3.58797V2.819H4.41177C4.6595 2.819 4.86099 3.02366 4.86099 3.27529V3.85774C4.86099 4.10936 4.6595 4.31402 4.41177 4.31402H4.2486V4.61129C4.2486 4.71933 4.16206 4.8079 4.05504 4.8079C3.94802 4.8079 3.86148 4.72 3.86148 4.61129V4.31402H3.64942C3.40169 4.31402 3.2002 4.10936 3.2002 3.85774V3.7249ZM2.31759 5.76825H10.5054C10.6118 5.76825 10.699 5.85616 10.699 5.96486C10.699 6.07357 10.6124 6.16146 10.5054 6.16146H2.31759C2.21123 6.16146 2.12404 6.07356 2.12404 5.96486C2.12404 5.85615 2.21058 5.76825 2.31759 5.76825ZM2.31759 7.01234H10.5054C10.6118 7.01234 10.699 7.10024 10.699 7.20894C10.699 7.31765 10.6124 7.40555 10.5054 7.40555L2.31759 7.40488C2.21123 7.40488 2.12404 7.31697 2.12404 7.20827C2.12404 7.09957 2.21058 7.01167 2.31759 7.01167V7.01234ZM2.31759 8.25575H10.5054C10.6118 8.25575 10.699 8.34366 10.699 8.45236C10.699 8.56107 10.6124 8.64897 10.5054 8.64897H2.31759C2.21123 8.64897 2.12404 8.56106 2.12404 8.45236C2.12404 8.34365 2.21058 8.25575 2.31759 8.25575ZM5.71388 13.624H2.35988C2.25351 13.624 2.16632 13.5361 2.16632 13.4274C2.16632 13.3187 2.25286 13.2308 2.35988 13.2308H5.71388C5.82024 13.2308 5.90744 13.3187 5.90744 13.4274C5.90744 13.5361 5.8209 13.624 5.71388 13.624ZM5.71388 12.3806H2.35988C2.25351 12.3806 2.16632 12.2926 2.16632 12.1839C2.16632 12.0752 2.25286 11.9873 2.35988 11.9873H5.71388C5.82024 11.9873 5.90744 12.0752 5.90744 12.1839C5.90744 12.2927 5.8209 12.3806 5.71388 12.3806ZM9.24817 11.1412H2.31759C2.21123 11.1412 2.12404 11.0533 2.12404 10.9446C2.12404 10.8359 2.21058 10.748 2.31759 10.748H9.24817C9.35453 10.748 9.44173 10.8359 9.44173 10.9446C9.44173 11.0533 9.35518 11.1412 9.24817 11.1412ZM9.24817 9.87293H2.31759C2.21123 9.87293 2.12404 9.78503 2.12404 9.67633C2.12404 9.56762 2.21058 9.47972 2.31759 9.47972H9.24817C9.35453 9.47972 9.44173 9.56763 9.44173 9.67633C9.44173 9.78503 9.35518 9.87293 9.24817 9.87293ZM15.5975 11.4921C15.2883 13.1744 14.3106 14.5346 12.692 15.535L12.6253 15.5766L12.5585 15.535C10.9532 14.5433 9.97808 13.1972 9.66098 11.5351L9.65371 11.4948L10.3751 9.81792L10.4577 9.81657C10.8125 9.80986 11.3059 9.70049 11.5682 9.63539C11.8179 9.57433 12.2797 9.4502 12.5691 9.30995L12.6246 9.28311L12.6801 9.30995C12.8981 9.41597 13.2515 9.52267 13.7304 9.62803C13.8427 9.65285 14.4221 9.77632 14.8172 9.79578L14.8971 9.79981L15.604 11.4525L15.5967 11.4921L15.5975 11.4921ZM14.3826 11.6357V12.7765C14.3826 12.8845 14.296 12.9731 14.189 12.9731H13.3837V13.7911C13.3837 13.8991 13.2972 13.9877 13.1902 13.9877H12.0671C11.9607 13.9877 11.8735 13.8998 11.8735 13.7911V12.9731H11.0682C10.9619 12.9731 10.8747 12.8852 10.8747 12.7765V11.6357C10.8747 11.5277 10.9612 11.4391 11.0682 11.4391H11.8735V10.6211C11.8735 10.5131 11.9601 10.4245 12.0671 10.4245H13.1902C13.2965 10.4245 13.3837 10.5124 13.3837 10.6211V11.4391H14.189C14.2954 11.4391 14.3826 11.527 14.3826 11.6357Z" fill="#757575" />
                </svg>

              }
            >
              Claims Manager
            </MenuItem>
          </OverlayTrigger>
        </>
      );
    }
  };

  const renderFax = () => {
    // if (hasModule('PO'))
    if (ModuleAccess("FAX", "")) {

      return (
        <>
          <OverlayTrigger
            overlay={(props) => <Tooltip {...props}>Fax</Tooltip>}
            placement="right"
            show={show && target == "fax"}
          >
            <MenuItem
              component={
                <Link
                  className={`${includes(pathname, "/fax") ? "active" : ""}`}
                  to="/fax"
                />
              }
              id="fax"
              onMouseEnter={() => handleMouseEnter("fax")}
              onMouseLeave={handleMouseLeave}
              icon={


                <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M14.8994 4.5H13.2995V2.09985C13.2995 1.21703 12.5817 0.5 11.6997 0.5H5.29954C4.41672 0.5 3.69969 1.2178 3.69969 2.09985V4.5H2.09985C1.21703 4.5 0.5 5.2178 0.5 6.09985V11.7005C0.5 12.5833 1.2178 13.3003 2.09985 13.3003H3.69969V14.9002C3.69969 15.783 4.41749 16.5 5.29954 16.5H11.6997C12.5825 16.5 13.2995 15.7822 13.2995 14.9002V13.3003H14.8994C15.7822 13.3003 16.4992 12.5825 16.4992 11.7005V6.09985C16.4992 5.21703 15.7814 4.5 14.8994 4.5ZM4.49923 2.09985C4.49923 1.65881 4.85776 1.29954 5.29954 1.29954H11.6997C12.1407 1.29954 12.5 1.65806 12.5 2.09985V4.5H4.49923V2.09985ZM12.4992 14.9002C12.4992 15.3412 12.1407 15.7005 11.6989 15.7005H5.29877C4.85774 15.7005 4.49846 15.3419 4.49846 14.9002V10.4996H12.4992V14.9002ZM14.4996 7.69969H13.6993C13.4781 7.69969 13.2995 7.52043 13.2995 7.29992C13.2995 7.07941 13.4781 6.90015 13.6993 6.90015H14.4996C14.7209 6.90015 14.8994 7.07941 14.8994 7.29992C14.8994 7.52043 14.7209 7.69969 14.4996 7.69969Z" fill="#757575" />
                  <path d="M5.69921 12.5002H11.2998C11.5211 12.5002 11.6996 12.321 11.6996 12.1005C11.6996 11.8799 11.5211 11.7007 11.2998 11.7007H5.69921C5.47795 11.7007 5.29944 11.8799 5.29944 12.1005C5.29944 12.321 5.47795 12.5002 5.69921 12.5002Z" fill="#757575" />
                  <path d="M5.69921 14.5002H11.2998C11.5211 14.5002 11.6996 14.321 11.6996 14.1005C11.6996 13.8799 11.5211 13.7007 11.2998 13.7007H5.69921C5.47795 13.7007 5.29944 13.8799 5.29944 14.1005C5.29944 14.321 5.47795 14.5002 5.69921 14.5002Z" fill="#757575" />
                </svg>

              }
            >
              Fax
            </MenuItem>
          </OverlayTrigger>
        </>
      );
    }
  };

  const renderProviders = () => {
    if (ModuleAccess("PRD", "")) {
      return (
        <>
          <OverlayTrigger
            overlay={(props) => <Tooltip {...props}>Providers</Tooltip>}
            placement="right"
            show={show && target == "providers"}
          >
            <MenuItem
              component={
                <Link
                  className={`${includes(pathname, "/providers") ? "active" : ""
                    }`}
                  to="/providers"
                />
              }
              id="providers"
              onMouseEnter={() => handleMouseEnter("providers")}
              onMouseLeave={handleMouseLeave}
              icon={

                <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M11.718 9.26665C11.8702 9.61794 11.9588 10.0478 11.9783 10.5449C12.4919 10.6626 12.8763 11.1219 12.8763 11.6706C12.8763 12.3077 12.3579 12.8261 11.7207 12.8261C11.0836 12.8261 10.5652 12.3077 10.5652 11.6706C10.5652 11.1282 10.9412 10.6736 11.4457 10.5493C11.4235 10.0556 11.3054 9.30452 10.8222 8.93367C10.5756 8.86985 10.3221 8.82363 10.062 8.7998C10.0428 9.66469 7.18418 11.7991 7.18418 11.7991C7.18418 11.7991 4.32462 9.66505 4.30524 8.80016C4.01636 8.82647 3.73529 8.87927 3.46382 8.95536C3.11129 9.23447 2.92889 9.75447 2.91947 10.5104C3.02311 10.5699 3.10684 10.6629 3.15822 10.7754C3.53796 10.9548 3.87342 11.3321 4.13031 11.8691C4.17333 11.9594 4.17902 12.0615 4.14738 12.1546C4.30133 12.5509 4.38933 12.984 4.38933 13.3477C4.38933 13.8574 4.38933 14.3394 3.83378 14.4631C3.77369 14.513 3.69831 14.5406 3.6192 14.5406H3.248C3.06187 14.5406 2.9104 14.3888 2.9104 14.2032L2.91076 14.19C2.91787 14.0105 3.06809 13.8656 3.248 13.8656H3.6192C3.65724 13.8656 3.6944 13.872 3.73031 13.8844C3.75271 13.8782 3.75982 13.873 3.76 13.8729C3.80124 13.7996 3.80124 13.4946 3.80124 13.3481C3.80124 13.0526 3.72729 12.6958 3.59769 12.3642C3.53049 12.326 3.47609 12.2682 3.44267 12.1984C3.2176 11.7271 2.91147 11.4227 2.66293 11.4227C2.40871 11.4227 2.08729 11.752 1.86311 12.2412C1.82649 12.321 1.76231 12.3859 1.68338 12.4249C1.56622 12.742 1.50187 13.0686 1.50187 13.3479C1.50187 13.4709 1.50187 13.7973 1.5488 13.8741C1.54933 13.8741 1.55982 13.8805 1.58933 13.8878C1.62773 13.873 1.66898 13.8654 1.71022 13.8654H2.08213C2.25547 13.8654 2.40036 13.9973 2.41778 14.1689L2.41956 14.1897C2.41956 14.389 2.26809 14.5408 2.08213 14.5408H1.71022C1.63644 14.5408 1.56516 14.5161 1.50649 14.4713C1.29404 14.4313 1.14436 14.3376 1.0496 14.185C0.934756 14.0007 0.913778 13.7586 0.913778 13.3479C0.913778 12.9877 0.996978 12.5728 1.14809 12.1765C1.12587 12.0917 1.13333 12.0032 1.17031 11.9234C1.32764 11.5792 1.52782 11.2844 1.74898 11.0713C1.87058 10.9541 2.00124 10.8599 2.13796 10.7911C2.18916 10.6713 2.27804 10.573 2.38667 10.5109C2.39236 10.0371 2.46524 9.62807 2.6 9.29083C1.05724 10.0734 0 11.6739 0 13.5223C0 15.8842 1.72569 15.9998 3.98471 15.9998C4.23129 15.9998 4.48373 15.9984 4.74169 15.9984H9.62471C9.88231 15.9984 10.1348 15.9998 10.3813 15.9998C12.6407 15.9998 14.3671 15.8842 14.3671 13.5223C14.3669 11.6544 13.2871 10.0398 11.718 9.26665Z" fill="#757575" />
                  <path d="M7.1848 9.4208C9.36862 9.4208 11.1388 6.13707 11.1388 3.95342C11.1388 1.77013 9.36862 0 7.1848 0C5.00133 0 3.2312 1.77013 3.2312 3.95342C3.2312 6.13707 5.00133 9.4208 7.1848 9.4208Z" fill="#757575" />
                  <path d="M11.7205 12.2044C12.015 12.2044 12.2538 11.9656 12.2538 11.671C12.2538 11.3765 12.015 11.1377 11.7205 11.1377C11.4259 11.1377 11.1871 11.3765 11.1871 11.671C11.1871 11.9656 11.4259 12.2044 11.7205 12.2044Z" fill="#757575" />
                </svg>


              }
            >
              Providers
            </MenuItem>
          </OverlayTrigger>
        </>
      );
    }

  };

  const renderLocations = () => {
    if (ModuleAccess("SL", "")) {

      return (
        <>
          <OverlayTrigger
            overlay={(props) => <Tooltip {...props}>Locations</Tooltip>}
            placement="right"
            show={show && target == "location"}
          >
            <MenuItem
              component={
                <Link
                  className={`${includes(pathname, "/location") ? "active" : ""}`}
                  to="/location"
                />
              }
              id="location"
              onMouseEnter={() => handleMouseEnter("location")}
              onMouseLeave={handleMouseLeave}
              icon={

                <svg width="11" height="17" viewBox="0 0 11 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M5.73697 0.5C2.84502 0.5 0.5 2.91567 0.5 5.8733C0.5 6.48351 0.758898 7.24813 1.14184 8.16235C1.52479 9.07659 2.04316 10.1165 2.59025 11.1557C3.68442 13.2343 4.90814 15.3236 5.41322 16.3018C5.44369 16.3615 5.49005 16.4116 5.54718 16.4465C5.60431 16.4815 5.67 16.5 5.73698 16.5C5.80396 16.5 5.86965 16.4815 5.92678 16.4465C5.98391 16.4116 6.03027 16.3615 6.06074 16.3018C6.56582 15.3236 7.78952 13.2343 8.88372 11.1557C9.4308 10.1165 9.94349 9.07659 10.3264 8.16235C10.7094 7.24813 10.974 6.48351 10.974 5.8733C10.974 2.91583 8.63062 0.5 5.73697 0.5ZM5.73697 3.45361C6.76959 3.45361 7.6114 4.2997 7.6114 5.3337C7.6114 6.36631 6.76959 7.21379 5.73697 7.21379C4.70437 7.21379 3.85689 6.36631 3.85689 5.3337C3.85689 4.2997 4.70437 3.45361 5.73697 3.45361Z" fill="#757575" />
                </svg>


              }
            >
              Locations
            </MenuItem>
          </OverlayTrigger>
        </>
      );
    }
  };

  const renderConfiguration = () => {
    // if (hasModule('PO'))
    if (ModuleAccess("CON", "")) {
      return (
        <>
          <OverlayTrigger
            overlay={(props) => <Tooltip {...props}>Configuration</Tooltip>}
            placement="right"
            show={show && target == "configuration"}
          >
            <MenuItem
              component={
                <Link
                  className={`${includes(pathname, "/configuration") ? "active" : ""
                    }`}
                  to="/configuration"
                />
              }
              id="configuration"
              onMouseEnter={() => handleMouseEnter("configuration")}
              onMouseLeave={handleMouseLeave}
              icon={


                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0_754_112382)">
                    <path d="M3.86194 8.81967L3.86197 8.81979C3.87188 8.80979 3.87122 8.81039 3.86194 8.81967Z" fill="#757575" />
                    <path d="M15.6453 6.6081L14.8496 6.41679C14.6766 5.66157 14.3787 4.94388 13.9622 4.27657L14.3654 3.59963C14.4753 3.4152 14.4455 3.17991 14.294 3.02841L12.9726 1.70701C12.8211 1.55598 12.5863 1.52576 12.4014 1.6356L11.7244 2.03882C11.0571 1.62232 10.3394 1.32435 9.5842 1.15135L9.39289 0.355727C9.3407 0.147477 9.15352 0.000976562 8.93839 0.000976562H7.06364C6.84852 0.000976562 6.66133 0.147445 6.60914 0.355727L6.41783 1.15135C5.66261 1.32435 4.94492 1.62232 4.27761 2.03882L3.60067 1.6356C3.41623 1.52573 3.18095 1.55551 3.02945 1.70701L1.70798 3.02838C1.55648 3.17988 1.52673 3.41513 1.63658 3.5996L2.0398 4.27654C1.6233 4.94385 1.32533 5.66154 1.15233 6.41676L0.356703 6.60807C0.148453 6.66026 0.00195312 6.84744 0.00195312 7.06257V8.93732C0.00195312 9.15244 0.148422 9.3401 0.357141 9.39182L1.15277 9.58313C1.26811 10.0836 1.4417 10.5644 1.66464 11.0255C2.00886 10.6799 3.73767 8.94363 3.86192 8.81954C3.8558 8.78798 3.78883 8.18763 3.78705 8.07069C3.74717 5.68235 5.67089 3.78216 8.0028 3.78216C10.3507 3.78216 12.2229 5.67535 12.214 8.01457C12.204 10.1779 10.5893 12.0196 8.3342 12.188C8.23664 12.1955 7.79558 12.2606 7.1808 12.1394L4.98108 14.3391C5.44045 14.5607 5.91942 14.7332 6.4178 14.8481L6.60911 15.6442C6.6613 15.8524 6.84848 15.9989 7.06361 15.9989H8.93836C9.15348 15.9989 9.34067 15.8525 9.39286 15.6442L9.58417 14.8486C10.3394 14.6756 11.0571 14.3776 11.7244 13.9611L12.4013 14.3643C12.5849 14.4742 12.8206 14.444 12.9725 14.2929L14.294 12.9715C14.4455 12.82 14.4752 12.5848 14.3654 12.4003L13.9621 11.7234C14.3791 11.056 14.6766 10.3384 14.8496 9.58266L15.6448 9.39182C15.8535 9.3401 16 9.15244 16 8.93732V7.06257C16 6.84748 15.8535 6.66026 15.6453 6.6081Z" fill="#757575" />
                    <path d="M11.1725 7.14308C11.1313 6.9817 11.0067 6.85476 10.8461 6.81076C10.6855 6.7667 10.5139 6.81261 10.3961 6.93036L9.32655 7.99995C8.96096 8.36554 8.36665 8.36554 8.00102 7.99995C7.63577 7.6347 7.63577 7.0397 8.00102 6.67442L9.07102 5.60442C9.18877 5.48667 9.23424 5.31479 9.19021 5.15426C9.14615 4.99373 9.01937 4.86895 8.85802 4.82795C6.88033 4.32536 5.10058 5.61358 4.77418 7.39254C4.66937 7.97842 4.71605 8.56198 4.9078 9.09932C4.64112 9.36604 0.521928 13.4852 0.411209 13.5959C-0.138509 14.1457 -0.138509 15.04 0.419897 15.5984C0.973084 16.1228 1.8203 16.1449 2.40496 15.5897L6.90158 11.0931C7.62168 11.3501 8.42477 11.3449 9.21068 11.0676C10.6268 10.5679 11.6179 8.89092 11.1725 7.14308Z" fill="#757575" />
                  </g>
                  <defs>
                    <clipPath id="clip0_754_112382">
                      <rect width="16" height="16" fill="white" />
                    </clipPath>
                  </defs>
                </svg>


              }
            >
              Configuration
            </MenuItem>
          </OverlayTrigger>
        </>
      );
    }
  };

  const renderINV = () => {
    // if (hasModule('PO'))
    if (ModuleAccess("INV", "")) {
      return (
        <>
          <OverlayTrigger
            overlay={(props) => <Tooltip {...props}>Invoice</Tooltip>}
            placement="right"
            show={show && target == "invoice"}
          >
            <MenuItem
              component={
                <Link
                  className={`${includes(pathname, "/invoice") ? "active" : ""}`}
                  to="/invoice"
                />
              }
              id="invoice"
              onMouseEnter={() => handleMouseEnter("invoice")}
              onMouseLeave={handleMouseLeave}
              icon={


                <svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12.1996 0C13.1896 0 14 0.771726 14 1.71458V14.2854C14 15.2283 14 16 14 16H1.80043C0.810426 16 0 15.2283 0 14.2854V1.71458C0 0.771726 0.810426 0 1.80043 0H12.1996ZM3 12.5719C2.67005 12.5719 2.4003 12.8285 2.40021 13.1427C2.40021 13.457 2.67 13.7146 3 13.7146H11C11.33 13.7146 11.5998 13.457 11.5998 13.1427C11.5997 12.8285 11.3299 12.5719 11 12.5719H3ZM3 10.2854C2.67 10.2854 2.40021 10.543 2.40021 10.8573C2.4003 11.1715 2.67005 11.4281 3 11.4281H11C11.3299 11.4281 11.5997 11.1715 11.5998 10.8573C11.5998 10.543 11.33 10.2854 11 10.2854H3ZM4.36364 2.66667C4.09734 2.66667 3.88104 2.87185 3.88104 3.12396V3.2625C3.88104 3.28119 3.8679 3.29808 3.84908 3.30417C3.60825 3.37936 3.38607 3.50938 3.20668 3.67917C2.89768 3.9717 2.72727 4.36163 2.72727 4.775C2.72733 5.18866 2.89782 5.57733 3.20668 5.86979C3.51568 6.16189 3.927 6.32396 4.36364 6.32396C4.54261 6.32396 4.71101 6.38952 4.83771 6.50938C4.96489 6.62934 5.0348 6.78942 5.0348 6.95938C5.03469 7.12918 4.9648 7.28803 4.83771 7.40833C4.711 7.52826 4.54313 7.59479 4.36364 7.59479C4.25207 7.59479 4.14122 7.56874 4.04297 7.51875C3.94479 7.46876 3.86216 7.394 3.80114 7.30625C3.73089 7.20504 3.62174 7.13518 3.49645 7.11042C3.46401 7.10395 3.43072 7.10002 3.39737 7.1C3.30371 7.1 3.21275 7.12632 3.13423 7.175C3.02737 7.24146 2.9527 7.34397 2.92649 7.4625C2.90033 7.58114 2.92445 7.70498 2.99467 7.80625C3.14343 8.02141 3.34932 8.19869 3.58807 8.32083C3.67205 8.3634 3.75974 8.39945 3.85014 8.42813C3.86888 8.43423 3.881 8.45117 3.88104 8.46979V8.60938C3.88104 8.86134 4.09755 9.06643 4.36364 9.06667C4.62948 9.06667 4.84624 8.86105 4.84624 8.60938V8.47083C4.84624 8.45214 4.85937 8.43525 4.8782 8.42917C5.11902 8.35354 5.3412 8.22395 5.5206 8.05417C5.8296 7.76164 6 7.3717 6 6.95833C5.99994 6.54468 5.82945 6.15601 5.5206 5.86354C5.21206 5.57145 4.79982 5.40938 4.36364 5.40938C4.18429 5.40926 4.01663 5.34322 3.88956 5.22292C3.76245 5.10296 3.69247 4.94386 3.69247 4.77396C3.69258 4.60372 3.76248 4.44427 3.88956 4.32396C4.01613 4.20389 4.18446 4.13865 4.36364 4.13854C4.47475 4.13854 4.58651 4.16356 4.6843 4.21354C4.78195 4.26391 4.86511 4.3384 4.92614 4.42604C4.99637 4.52774 5.10551 4.59813 5.23082 4.62292C5.35604 4.64767 5.48612 4.62468 5.59304 4.55833C5.7 4.49184 5.7746 4.38843 5.80078 4.26979C5.82692 4.15126 5.80266 4.02829 5.7326 3.92708C5.58384 3.71192 5.37781 3.53464 5.13814 3.4125C5.05474 3.37001 4.96739 3.33385 4.87713 3.30521C4.85833 3.29913 4.84521 3.2822 4.84517 3.26354V3.12396C4.84517 2.87243 4.62927 2.6669 4.36364 2.66667ZM7.80043 7.46146C7.47043 7.46146 7.19957 7.71905 7.19957 8.03333C7.19981 8.34743 7.47057 8.60417 7.80043 8.60417H11C11.3299 8.60417 11.5996 8.34743 11.5998 8.03333C11.5998 7.71905 11.33 7.46146 11 7.46146H7.80043ZM7.80043 5.17604C7.47054 5.17604 7.19977 5.43274 7.19957 5.74688C7.19957 6.06116 7.47043 6.31875 7.80043 6.31875H11C11.33 6.31875 11.5998 6.06116 11.5998 5.74688C11.5996 5.43274 11.3299 5.17604 11 5.17604H7.80043ZM7.80043 2.88958C7.47044 2.88958 7.19959 3.14719 7.19957 3.46146C7.19957 3.77574 7.47043 4.03333 7.80043 4.03333H11C11.33 4.03333 11.5998 3.77574 11.5998 3.46146C11.5998 3.14719 11.33 2.88958 11 2.88958H7.80043Z" fill="#757575" />
                </svg>

              }
            >
              Invoice
            </MenuItem>
          </OverlayTrigger>
        </>
      );
    }
  };
  const renderDashboard = () => {
    if (ModuleAccess('DB'))
      return (
        <>
          <OverlayTrigger
            overlay={(props) => <Tooltip {...props}>Dashboard</Tooltip>}
            placement="right"
            show={show && target == "dashboard"}
          >
            <MenuItem
              component={
                <Link
                  className={`${includes(pathname, "/dashboard") ? "active" : ""
                    }`}
                  to="/dashboard"
                />
              }
              id="dashboard"
              onMouseEnter={() => handleMouseEnter("dashboard")}
              onMouseLeave={handleMouseLeave}
              icon={


                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M6 1H2C1.44875 1 1 1.44875 1 2V6C1 6.55125 1.44875 7 2 7H6C6.55125 7 7 6.55125 7 6V2C7 1.44875 6.55125 1 6 1Z" fill="#757575" />
                  <path d="M14 1H10C9.44875 1 9 1.44875 9 2V6C9 6.55125 9.44875 7 10 7H14C14.5512 7 15 6.55125 15 6V2C15 1.44875 14.5512 1 14 1Z" fill="#757575" />
                  <path d="M6 9H2C1.44875 9 1 9.44875 1 10V14C1 14.5512 1.44875 15 2 15H6C6.55125 15 7 14.5512 7 14V10C7 9.44875 6.55125 9 6 9Z" fill="#757575" />
                  <path d="M14 9H10C9.44875 9 9 9.44875 9 10V14C9 14.5512 9.44875 15 10 15H14C14.5512 15 15 14.5512 15 14V10C15 9.44875 14.5512 9 14 9Z" fill="#757575" />
                </svg>

              }
            >
              Dashboard
            </MenuItem>
          </OverlayTrigger>
        </>
      );
  };
  const collapse = () => {
    return (
      <MenuItem
        component={<Link onClick={() => setOpen(!open)} />}
        icon={
          open ? (
            <FontAwesomeIcon
              style={{ color: "757575" }}
              icon={faChevronCircleRight}
              className="fa-fw"
            />
          ) : (
            <FontAwesomeIcon
              style={{ color: "757575" }}
              icon={faChevronCircleLeft}
              className="fa-fw"
            />
          )
        }
      >
        Collapse
      </MenuItem>
    );
  };

  return (
    <div>
      <div className="app-sider">
        <div className="app-sider-inner">
          <Sidebar collapsed={open}>
            <Menu closeOnClick={true}>
              {renderDashboard()}
              {renderTaskBoard()}
              {renderClaimsManager()}
              {renderFax()}
              {renderProviders()}
              {renderLocations()}
              {renderConfiguration()}
              {renderINV()}
              {collapse()}
            </Menu>
          </Sidebar>
        </div>
      </div>
    </div>
  );
};

export default SidebarMenu;
